import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {take} from 'rxjs/operators';
import {OrdersService} from '../../../../../shared/services/orders.service';

@Component({
  selector: 'app-toxicology-other-medications',
  templateUrl: './toxicology-other-medications.component.html',
  styleUrls: ['./toxicology-other-medications.component.scss']
})
export class ToxicologyOtherMedicationsComponent implements OnInit, OnChanges {
  @Input() public orderId: number = -1;
  public isLoading = false;
  public hasResults = false;
  public results: string | undefined = '';

  constructor(private orderService: OrdersService) {
  }

  public ngOnInit() {
    this.isLoading = true;
    this.orderService.getOrderToxicologyOtherMedications(this.orderId)
      .pipe(take(1)).subscribe(results => {
      if (results.length > 0) {
        this.results = results.length === 1 ? results[0].medicationName : results.map(r => r.medicationName).join(', ');
        if (!this.results) this.results = '';
        this.hasResults = true;
      } else {
        this.hasResults = false;
      }
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.orderId.currentValue) {
      this.isLoading = true;
      this.orderService.getOrderToxicologyOtherMedications(changes.orderId.currentValue)
        .pipe(take(1)).subscribe(results => {
        if (results.length > 0) {
          this.results = results.length === 1 ? results[0].medicationName : results.map(r => r.medicationName).join(', ');
          this.hasResults = true;
        } else {
          this.hasResults = false;
        }
      });
    }
  }
}
